exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parentEmailsModal table{font-size:.8em}.parentEmailsModal table .glyphicon-ok{color:#2b9401;left:25px}.parentEmailsModal .studentName{width:200px}.parentEmailsModal .parentEmailTable .errorRow{border:1px solid #da3956}.parentEmailsModal .parentEmailTable .instructionsText{font-size:16px}.parentEmailsModal .parentEmailTable .editLink{cursor:pointer}.parentEmailsModal .parentEmailTable .editLink:hover .glyphicon-pencil{display:inline-block!important;position:relative;left:5px;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster/parent_emails_modal.scss
// module id = 1364
// module chunks = 0